import React from 'react'
import StatusPill from '@Components/StatusPills/StatusPill'

const memberStatusLabels: Record<string, string> = {
    IN_REVIEW: 'In Review',
}

interface OverclaimMemberStatusPillProps {
    status: string
}

const formatMemberStatus = (status: string) =>
    memberStatusLabels[status] ?? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()

const OverclaimMemberStatusPill = ({ status }: OverclaimMemberStatusPillProps) => (
    <StatusPill text={formatMemberStatus(status)} color="gray" />
)

export default OverclaimMemberStatusPill
